import { render } from "./admin-set.vue?vue&type=template&id=4e68dc21&scoped=true&ts=true"
import script from "./admin-set.vue?vue&type=script&lang=ts"
export * from "./admin-set.vue?vue&type=script&lang=ts"

import "./admin-set.vue?vue&type=style&index=0&id=4e68dc21&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e68dc21"]])

export default __exports__